function ArrowControls (Glide) {
  const CLASSES = Glide.settings.arrowClasses;
  const GLIDE_PARENT = document.querySelector(Glide.selector).parentNode;
  const BACK_ARROW = GLIDE_PARENT.querySelector('.' + CLASSES.back);
  const NEXT_ARROW = GLIDE_PARENT.querySelector('.' + CLASSES.next);

  return {
    mount() {
      BACK_ARROW.addEventListener('click', function() { Glide.go('<'); });
      NEXT_ARROW.addEventListener('click', function() { Glide.go('>'); });
    }
  }
}

function ArrowDisabler (Glide, Components) {
  const CLASSES = Glide.settings.arrowClasses;
  const GLIDE_PARENT = document.querySelector(Glide.selector).parentNode;
  const BACK_ARROW = GLIDE_PARENT.querySelector('.' + CLASSES.back);
  const NEXT_ARROW = GLIDE_PARENT.querySelector('.' + CLASSES.next);

  return {
    mount() {
      if (Glide.settings.rewind) {
        return;
      }

      Glide.on(['mount.after', 'run', 'resize'], () => {
        const lastSlideIndex = Glide.settings.bound ? Glide.index + (Glide.settings.perView - 1) : Glide.index;
        const isLastSlide = lastSlideIndex === Components.Sizes.length - 1;
        const isFirstSlide = Glide.index === 0;
        const notEnoughSlides = Components.Sizes.length <= Glide.settings.perView;

        isFirstSlide ? BACK_ARROW.classList.add(CLASSES.disabled) : BACK_ARROW.classList.remove(CLASSES.disabled);
        isLastSlide || notEnoughSlides ? NEXT_ARROW.classList.add(CLASSES.disabled) : NEXT_ARROW.classList.remove(CLASSES.disabled);
      });
    }
  }
}

function ArrowResizer (Glide, Components) {
  return {
    mount() {
      Glide.on(['mount.after', 'resize'], () => {
        Components.Sizes.length <= Glide.settings.perView ? Glide.disable() : Glide.enable()
      });
    }
  }
}

module.exports = { ArrowControls, ArrowDisabler, ArrowResizer }



// WEBPACK FOOTER //
// ./resources/js/utils/_glide-plugins.js